import type { OrganizationPublic } from '@garden-platform/shared';
import { Building2 } from 'lucide-react';
import { Link } from 'react-router-dom';

import { SidebarMenu, SidebarMenuButton, SidebarMenuItem } from '@/components/ui/sidebar';

interface OrgSwitcherProps {
  organization: OrganizationPublic | null;
}

export function OrgSwitcher({ organization }: OrgSwitcherProps) {
  return (
    <SidebarMenu>
      <SidebarMenuItem>
        <SidebarMenuButton size="lg" asChild>
          <Link to="/dashboard">
            <div className="bg-sidebar-primary text-sidebar-primary-foreground flex aspect-square size-8 items-center justify-center rounded-lg">
              <Building2 className="size-4" />
            </div>
            <div className="grid flex-1 text-left text-sm leading-tight">
              <span className="truncate font-semibold">
                {organization?.name || 'Garden Platform'}
              </span>
              <span className="truncate text-xs text-muted-foreground">Title Company</span>
            </div>
          </Link>
        </SidebarMenuButton>
      </SidebarMenuItem>
    </SidebarMenu>
  );
}
